import { z } from 'zod';

export const ExternalDagsterTransform = z.object({
  id: z.string(),
  name: z.string(),
  database: z.string(),
  schema: z.string(),
  tableName: z.string(),
  dictionaryTableName: z.string().nullable().default(null),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});

export type ExternalDagsterTransform = z.infer<typeof ExternalDagsterTransform>;

export const ExternalDagsterTransforms = z.array(ExternalDagsterTransform);

export type ExternalDagsterTransforms = z.infer<typeof ExternalDagsterTransforms>;

export const CreateExternalDagsterTransformRequest = z.object({
  name: z.string(),
  database: z.string(),
  schema: z.string(),
  tableName: z.string(),
  dictionaryTableName: z.string().nullable().optional(),
});

export type CreateExternalDagsterTransformRequest = z.infer<
  typeof CreateExternalDagsterTransformRequest
>;

export const UpdateExternalDagsterTransformRequest = z.object({
  name: z.string().optional(),
  database: z.string().optional(),
  schema: z.string().optional(),
  tableName: z.string().optional(),
  dictionaryTableName: z.string().nullable().optional(),
});

export type UpdateExternalDagsterTransformRequest = z.infer<
  typeof UpdateExternalDagsterTransformRequest
>;

export const OrganizationExternalDagsterTransformEntitlement = z.object({
  id: z.string(),
  organizationId: z.string(),
  dagsterTransformId: z.string(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});

export type OrganizationExternalDagsterTransformEntitlement = z.infer<
  typeof OrganizationExternalDagsterTransformEntitlement
>;

export const OrganizationExternalDagsterTransformEntitlements = z.array(
  OrganizationExternalDagsterTransformEntitlement,
);

export type OrganizationExternalDagsterTransformEntitlements = z.infer<
  typeof OrganizationExternalDagsterTransformEntitlements
>;

export const OrganizationEntitledDagsterTransform = z.object({
  entitlementId: z.string(),
  organizationId: z.string(),
  entitledAt: z.coerce.date(),
  transformId: z.string(),
  name: z.string(),
  database: z.string(),
  schema: z.string(),
  tableName: z.string(),
  dictionaryTableName: z.string().nullable().default(null),
});

export type OrganizationEntitledDagsterTransform = z.infer<
  typeof OrganizationEntitledDagsterTransform
>;

export const OrganizationEntitledDagsterTransforms = z.array(
  OrganizationEntitledDagsterTransform,
);

export type OrganizationEntitledDagsterTransforms = z.infer<
  typeof OrganizationEntitledDagsterTransforms
>;

export const GrantOrganizationDagsterTransformAccessRequest = z.object({
  organizationId: z.string(),
  dagsterTransformId: z.string(),
});

export type GrantOrganizationDagsterTransformAccessRequest = z.infer<
  typeof GrantOrganizationDagsterTransformAccessRequest
>;
